import { BlurView } from 'expo-blur';
import React from 'react';
import { Pressable, Text, View } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import { styles } from './styles';

const ExitCard = ({ handleEnd, setRenderExitCard, setGivenUp }) => {
  const { width, height } = useSafeAreaFrame();

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View style={styles.container}>
          <Text style={[styles.title, { marginBottom: 60 }]}>Deseja realmente sair?</Text>

          <View style={{ flexDirection: 'row', justifyContent: 'space-evenly', width: '100%' }}>
            <Pressable
              onPress={() => {
                setGivenUp(true);
                setRenderExitCard(false);
              }}
              style={styles.buttonExit}>
              <Text style={[styles.textBack, { color: 'white' }]}>Desistir</Text>
            </Pressable>
            <Pressable
              onPress={() => {
                setRenderExitCard(false);
              }}
              style={styles.buttonContinue}>
              <Text style={styles.textBack}>{'Continuar\nJogando'}</Text>
            </Pressable>
          </View>
        </View>
      </BlurView>
    </View>
  );
};

export default ExitCard;
